import React from "react";

/**
 * LeaderboardChampionCard — "Last month's top referrer"
 *
 * Generated on the 1st of each month by the LeaderboardService::monthlyReset().
 * Shows the champion's display name, tier, and placement count.
 *
 * Props:
 *   card — feed card object with metadata containing:
 *     display_name, tier, placement_count, period_month
 */
const LeaderboardChampionCard = ({ card }) => {
  const meta = card.metadata || {};
  const tier = meta.tier || "bronze";

  const tierStyles = {
    bronze:   { bg: "#f5e6d3", color: "#8b4513", label: "BRONZE" },
    silver:   { bg: "#e8e8e8", color: "#555",    label: "SILVER" },
    gold:     { bg: "#fef3c7", color: "#a16207", label: "GOLD" },
    platinum: { bg: "#e0f2fe", color: "#0369a1", label: "PLATINUM" },
  };

  const ts = tierStyles[tier] || tierStyles.bronze;
  const monthLabel = meta.period_month
    ? new Date(meta.period_month + "-01").toLocaleDateString("en-US", { month: "long", year: "numeric" })
    : "Last month";

  return (
    <div style={styles.card}>
      <div style={styles.row}>
        <div style={styles.iconWrap}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2">
            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
            <path d="M4 22h16" />
            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
            <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
          </svg>
        </div>

        <div style={styles.content}>
          <p style={styles.message}>
            <strong>{meta.display_name || "A referrer"}</strong> was {monthLabel}'s champion with{" "}
            {meta.placement_count || 0} successful placements!
          </p>
          <div style={styles.metaRow}>
            <span style={{ ...styles.tierBadge, backgroundColor: ts.bg, color: ts.color }}>
              {ts.label}
            </span>
            <span style={styles.timestamp}>{formatTime(card.created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

function formatTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const diffHrs = (now - date) / (1000 * 60 * 60);
  if (diffHrs < 1) return "Just now";
  if (diffHrs < 24) return `${Math.floor(diffHrs)}h ago`;
  const diffDays = Math.floor(diffHrs / 24);
  if (diffDays === 1) return "1d ago";
  return `${diffDays}d ago`;
}

const styles = {
  card: {
    backgroundColor: "#fffbeb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    marginBottom: "16px",
    padding: "18px 20px",
    border: "1px solid #fde68a",
  },
  row: {
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
  },
  iconWrap: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    backgroundColor: "#fef3c7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  message: {
    fontSize: "15px",
    color: "#0f172a",
    margin: "0 0 8px 0",
    lineHeight: 1.4,
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  tierBadge: {
    fontSize: "11px",
    fontWeight: "700",
    padding: "3px 10px",
    borderRadius: "5px",
    letterSpacing: "0.3px",
  },
  timestamp: {
    fontSize: "12px",
    color: "#94a3b8",
  },
};

export default LeaderboardChampionCard;
